import { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { FullPageLoader, PageContentLayout } from '@tassomutuo-backoffice/ui';

import DashboardContent from './components/DashboardContent';
import useDashboardPdf from './hooks/useDashboardPdf';
import DashboardHeaderSection from './components/DashboardHeaderSection';
import useStatistics from './hooks/useStatistics';

const DashboardPage = () => {
  const { isPrinting, generatePdf } = useDashboardPdf({ from: 'dashboard' });
  const contentPrintableRef = useRef<HTMLDivElement>(null);

  const {
    isPending,
    error,
    isTeamStatistics,
    selectedPeriod,
    setSelectedPeriod,
    selectedComparisonPeriod,
    setSelectedComparisonPeriod,
    selectedMember,
    setSelectedMember,
    teamGroups,
    memberSelectOptions,
    selectedGroupId,
    setSelectedGroupId,
    statisticsToShow,
    benchmarkStatistics,
    dateRange,
    setDateRange,
    getFilterText,
  } = useStatistics({ from: 'dashboard' });

  return (
    <Box sx={{ backgroundColor: '#E9EAEB', minHeight: '100vh' }}>
      <FullPageLoader show={isPending || isPrinting} />

      <PageContentLayout error={error} containerSx={{ pt: 0 }}>
        <DashboardHeaderSection
          title="La tua Dashboard"
          subtitle={
            isTeamStatistics
              ? 'Monitora le performance dei tuoi consulenti'
              : 'Monitora le tue performance'
          }
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          selectedComparisonPeriod={selectedComparisonPeriod}
          setSelectedComparisonPeriod={setSelectedComparisonPeriod}
          onExportPdfClick={() =>
            generatePdf('download', contentPrintableRef, getFilterText())
          }
          selectedMember={selectedMember}
          setSelectedMember={setSelectedMember}
          teamGroups={teamGroups || []}
          memberSelectOptions={memberSelectOptions}
          selectedGroupId={selectedGroupId}
          setSelectedGroupId={setSelectedGroupId}
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
        {/* This div is what html2canvas will capture */}
        {!selectedMember ||
        (selectedMember && !!selectedMember.hubspotOwnerId) ? (
          <Box
            ref={contentPrintableRef}
            sx={{ px: 0, pb: 4, width: isPrinting ? 1100 : undefined }}
          >
            <DashboardContent
              isTeamStatistics={isTeamStatistics}
              funnelPerStageStatistics={
                statisticsToShow?.funnelPerStageStatistics
              }
              statisticsAllPeriod={statisticsToShow?.statisticsAllPeriod}
              statisticsAllPeriodTrend={
                statisticsToShow?.statisticsAllPeriodTrend
              }
              statisticsPerMonth={statisticsToShow?.statisticsPerMonth}
              benchmarkStatistics={benchmarkStatistics}
              showAllCharts={isPrinting}
              isPrinting={isPrinting}
              droppedReasons={statisticsToShow?.droppedReasons}
            />
          </Box>
        ) : (
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight="bold" px={4} pt={1}>
              Non ci sono dati da mostrare per il membro selezionato
            </Typography>
          </Box>
        )}
      </PageContentLayout>
    </Box>
  );
};

export default DashboardPage;
